import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { BsThreeDotsVertical } from 'react-icons/bs'

import type { Props as MenuProps } from './Menu'
import type { ReactElement, MouseEvent } from 'react'

import Menu from './Menu'

import { useOnClickOutside } from '~/hooks/useOnClickOutside'

import './styles.scss'

export interface Props {
  className?: string
  menu: MenuProps['menu']
  onMouseDown?: (e: MouseEvent) => void
}

const DropdownMenu = ({ className, menu, onMouseDown }: Props): ReactElement => {
  /** Local state */

  const menuRef = useRef<HTMLDivElement>(null)

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  /** Effects */

  useOnClickOutside(menuRef, () => setIsMenuOpen(false))

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange)
  }, [])

  /** Handlers */

  const handleToggle = () => setIsMenuOpen(!isMenuOpen)

  /** Render */

  return (
    <div className={classNames('dropdown-menu-component', className)} onMouseDown={onMouseDown} ref={menuRef}>
      <button className="toggle-button" onClick={handleToggle} type="button">
        <BsThreeDotsVertical className="dropdown-menu-icon" color="#aeaeae" size={17} />
      </button>
      <Menu isMenuOpen={isMenuOpen} menu={menu} />
    </div>
  )
}

export default DropdownMenu
